/*
Copyright (c) 2012-2026 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/
export enum EventAction {
  clickProfile = "CLICK_PROFILE",
  changeLanguage = "CHANGE_LANGUAGE",
  clickDownloadCSV = "CLICK_DOWNLOAD_CSV",
  clickStoreName = "CLICK_STORE_NAME",
  clickFilter = "CLICK_FILTER",
  clickStores = "CLICK_STORES",
  clickOrdersTab = "CLICK_ORDERS_TAB",
  clickTransactionsTab = "CLICK_TRANSACTIONS_TAB",
  clickInstoreOVOTransactionsTab = "CLICK_INSTORE_OVO_TRANSACTIONS_TAB",
  searchStore = "SEARCH_STORE",
  searchItem = "SEARCH_ITEM",
  clickStoreSearchResult = "CLICK_STORE_SEARCH_RESULT",
  loadNextPage = "LOAD_NEXT_PAGE",
  searchBookingID = "SEARCH_BOOKING_ID",
  searchLongOrderID = "SEARCH_LONG_ORDER_ID",
  searchShortOrderID = "SEARCH_SHORT_ORDER_ID",
  searchTransactionID = "SEARCH_TRANSACTION_ID",
  clickExpand = "CLICK_EXPAND",
  clickCollapse = "CLICK_COLLAPSE",
  clickTransactionID = "CLICK_TRANSACTION_ID",
  clickLearnmore = "CLICK_LEARNMORE",
  clickDownloadcsv = "CLICK_DOWNLOADCSV",
  clickBack = "CLICK_BACK",
  clickCancel = "CLICK_CANCEL",
  pageLoad = "PAGE_LOAD",
  redirectToHome = "REDIRECT_TO_HOME",
  emptyOutlets = "EMPTY_OUTLETS",
  // Troy MME
  pageView = "PAGEVIEW",
  clickTabOverview = "CLICK_TAB_OVERVIEW",
  clickTabItems = "CLICK_TAB_ITEMS",
  clickTabModifierGroups = "CLICK_TAB_MODIFIER_GROUPS",
  clickItemSearch = "CLICK_ITEM_SEARCH",
  clickStoreSearch = "CLICK_STORE_SEARCH",
  selectItemSearchResults = "SELECT_ITEM_SEARCHRESULTS",
  selectStoreName = "SELECT_STORE_NAME",
  clickAddItem = "CLICK_ADD_ITEM",
  clickEditItem = "CLICK_EDIT_ITEM",
  submitItemAvailability = "SUBMIT_ITEM_AVAILABILITY",
  submitDeleteItem = "SUBMIT_DELETE_ITEM",
  submitDeleteCategory = "SUBMIT_DELETE_CATEGORY",
  submitDeleteSection = "SUBMIT_DELETE_SECTION",
  submitModifySection = "SUBMIT_MODIFY_SECTION",
  submitModifyCategory = "SUBMIT_MODIFY_CATEGORY",
  clickAddCategory = "CLICK_ADD_CATEGORY",
  selectSection = "SELECT_SECTION",
  clickAddSection = "CLICK_ADD_SECTION",
  clickEditSection = "CLICK_EDIT_SECTION",
  clickSellingTime = "CLICK_SELLING_TIME",
  selectSellingTime = "SELECT_SELLING_TIME",
  clickAddSellingTime = "CLICK_ADD_SELLING_TIME",
  addSellingTime = "ADD_SELLING_TIME",
  setMultiSelectSellingTime = "SET_MULTISELECT_SELLING_TIME",
  clickEditSellingTime = "CLICK_EDIT_SELLING_TIME",
  clickEditTiming = "CLICK_EDIT_TIMING",
  clickExitEditTiming = "CLICK_EXIT_EDIT_TIMING",
  clickSetTiming = "CLICK_SET_TIMING",
  clickPreview = "CLICK_PREVIEW",
  clickCategoryMore = "CLICK_CATEGORY_MORE",
  clickCategoryName = "CLICK_CATEGORY_NAME",
  clickDepartmentMore = "CLICK_CATEGORY_MORE",
  clickSubDepartmentMore = "CLICK_SUBCATEGORY_MORE",
  clickDepartmentName = "CLICK_CATEGORY_NAME",
  clickSubDepartmentName = "CLICK_SUBCATEGORY_NAME",
  clickItemMore = "CLICK_ITEM_MORE",
  clickChangeAvailability = "CLICK_CHANGE_AVAIBILITY",
  clickDeleteItem = "CLICK_DELETE_ITEM",
  clickExitItemAction = "CLICK_EXIT_ITEM_ACTION",
  clickEditCategory = "CLICK_EDIT_CATEGORY",
  clickSelectAllCategory = "CLICK_SELECTALL_CATEGORY",
  clickSelectAllDepartment = "CLICK_SELECTALL_CATEGORY",
  clickDeleteCategory = "CLICK_DELETE_CATEGORY",
  clickExit = "CLICK_EXIT",
  rearrangeItem = "REARRANGE_ITEM",
  submitRearrangeItem = "SUBMIT_REARRANGE_ITEM",
  rearrangeCategory = "REARRANGE_CATEGORY",
  rearrangeDepartment = "REARRANGE_CATEGORY",
  rearrangeSubDepartment = "REARRANGE_SUBCATEGORY",
  submitRearrangeCategory = "SUBMIT_REARRANGE_CATEGORY",
  submitRearrangeDepartment = "SUBMIT_REARRANGE_CATEGORY",
  submitRearrangeSubDepartment = "SUBMIT_REARRANGE_SUBCATEGORY",
  selectStoreSearchresult = "SELECT_STORE_SEARCHRESULTS",
  clickFilterCity = "CLICK_FILTER_CITY",
  selectFilterCity = "SELECT_FILTER_CITY",
  clickEditPhoto = "CLICK_EDIT_PHOTO",
  clickAddPhoto = "CLICK_ADD_PHOTO",
  clickPreviewItem = "CLICK_PREVIEW_ITEM",
  submitModifyItem = "SUBMIT_MODIFY_ITEM",
  itemValidation = "ITEM_VALIDATION",
  itemValidationCompare = "ITEM_VALIDATION_COMPARE",
  submitAddPhoto = "SUBMIT_ADD_PHOTO",
  imageCompressionFailed = "IMAGE_COMPRESSION_FAILED",
  grabMexProImageEditorEditingStarted = "GRAB_MEX_PRO_IMAGE_EDITOR_EDITING_STARTED",
  grabMexProImageEditorClose = "GRAB_MEX_PRO_IMAGE_EDITOR_CLOSE",
  grabMexProImageEditorEnhanceImage = "GRAB_MEX_PRO_IMAGE_EDITOR_ENHANCE_IMAGE",
  grabMexProImageEditorError = "GRAB_MEX_PRO_IMAGE_EDITOR_ERROR",
  grabMexProImageEditorAutoEnhanceStart = "GRAB_MEX_PRO_IMAGE_EDITOR_AUTO_ENHANCE_START",
  grabMexProImageEditorAutoEnhanceEnd = "GRAB_MEX_PRO_IMAGE_EDITOR_AUTO_ENHANCE_END",
  grabMexProImageEditorCropImage = "GRAB_MEX_PRO_IMAGE_EDITOR_CROP_IMAGE",
  grabMexProImageEditorAutoAdjustEnd = "GRAB_MEX_PRO_IMAGE_EDITOR_AUTO_ADJUST_END",
  grabMexProImageEditorAdjustBrightnessManually = "GRAB_MEX_PRO_IMAGE_EDITOR_ADJUST_BRIGHTNESS_MANUALLY",
  grabMexProImageEditorAdjustContrastManually = "GRAB_MEX_PRO_IMAGE_EDITOR_ADJUST_CONTRAST_MANUALLY",
  grabMexProImageEditorAutoRemoveBackgroundStart = "GRAB_MEX_PRO_IMAGE_EDITOR_AUTO_REMOVE_BACKGROUND_START",
  grabMexProImageEditorAutoRemoveBackgroundEnd = "GRAB_MEX_PRO_IMAGE_EDITOR_AUTO_REMOVE_BACKGROUND_END",
  grabMexProImageEditorSaveOrCancel = "GRAB_MEX_PRO_IMAGE_EDITOR_SAVE_OR_CANCEL",
  clickSortPrice = "CLICK_SORT_PRICE",
  clickFilterCategory = "CLICK_FILTER_CATEGORY",
  selectFilterCategory = "SELECT_FILTER_CATEGORY",
  clickFilterDepartment = "CLICK_FILTER_CATEGORY",
  selectFilterDepartment = "SELECT_FILTER_CATEGORY",
  clickFilterSubDepartment = "CLICK_FILTER_SUBCATEGORY",
  selectFilterSubDepartment = "SELECT_FILTER_SUBCATEGORY",
  selectFilterStatus = "SELECT_FILTER_STATUS",
  clickFilterStatus = "CLICK_FILTER_STATUS",
  clickAddModifiergroup = "CLICK_ADD_MODIFIERGROUP",
  clickModifiergroupSearch = "CLICK_MODIFIERGROUP_SEARCH",
  selectModifiergroupSearchresult = "SELECT_MODIFIERGROUP_SEARCHRESULTS",
  clickModifiergroupMore = "CLICK_MODIFIERGROUP_MORE",
  clickModifierMore = "CLICK_MODIFIER_MORE",
  clickExitModifierAction = "CLICK_EXIT_MODIFIER_ACTION",
  clickEditModifier = "CLICK_EDIT_MODIFIER",
  clickEditModifiergroup = "CLICK_EDIT_MODIFIERGROUP",
  submitDeleteModifiergroup = "SUBMIT_DELETE_MODIFIERGROUP",
  clickDeleteModifiergroup = "CLICK_DELETE_MODIFIERGROUP",
  clickEditLinkedItem = "CLICK_EDIT_LINKEDITEM",
  clickLinkItem = "CLICK_LINK_ITEM",
  submitModifierAvailability = "SUBMIT_MODIFIER_AVAILABILITY",
  submitModifyModifiergroup = "SUBMIT_MODIFY_MODIFIERGROUP",
  submitRearrangeModifier = "SUBMIT_REARRANGE_MODIFIER",
  rearrangeModifier = "REARRANGE_MODIFIER",
  clickPreviewModifiergroup = "CLICK_PREVIEW_MODIFIERGROUP",
  applySellingTime = "APPLY_SELLING_TIME",
  clickRemoveSellingTime = "CLICK_REMOVE_SELLING_TIME",
  cancelRemoveSellingTime = "CANCEL_REMOVE_SELLING_TIME",
  removeSellingTime = "REMOVE_SELLING_TIME",
  loadPage = "LOAD_PAGE",
  // Menu Group
  clickCreateNewMenu = "CLICK_CREATE_NEW_MENU",
  clickMenuGroupSearch = "CLICK_MENU_GROUP_SEARCH",
  clickNext = "CLICK_NEXT",
  clickPrevious = "CLICK_PREVIOUS",
  clickUseExistingMenu = "CLICK_USE_EXISTING_MENU",
  clickSearchMenuName = "CLICK_SEARCH_MENU_NAME",
  selectMenuName = "SELECT_MENU_NAME",
  clickConfirm = "CLICK_CONFIRM",
  clickPublish = "CLICK_PUBLISH",
  clickReset = "CLICK_RESET",
  clickConfirmPublish = "CLICK_CONFIRM_PUBLISH",
  clickConfirmReset = "CLICK_CONFIRM_RESET",
  clickMenuTitleMore = "CLICK_MENU_TITLE_MORE",
  clickStoresLinked = "CLICK_STORES_LINKED",
  clickEditName = "CLICK_EDIT_NAME",
  clickDelete = "CLICK_DELETE",
  clickMenu = "CLICK_MENU",
  clickMenuGroup = "CLICK_MENU_GROUP",
  clickInventory = "CLICK_INVENTORY",
  clickSave = "CLICK_SAVE",
  clickUnlink = "CLICK_UNLINK",
  clickLinkNewStores = "CLICK_LINK_NEW_STORES",
  default = "RECOMMENDATION_VIEW_AR", // display of actionable recommendation
  clickAR = "RECOMMENDATION_CLICK_AR", // Click Actionable Recommendation
  skipAR = "RECOMMENDATION_SKIP_AR", // Click Actionable Recommendation skip button
  clickItemWithoutPhoto = "CLICK_ITEM_WITHOUT_PHOTO",
  // Inventory
  clickEditinventory = "CLICK_EDITINVENTORY",
  clickDownloadcatalogue = "CLICK_DOWNLOADCATALOGUE",
  clickPreparebulk = "CLICK_PREPAREBULK",
  dragReplaceFile = "DRAG_REPLACE_FILE",
  clickUploaditems = "CLICK_UPLOADITEMS",
  editSuccessfulShown = "EDIT_SUCCESSFUL_SHOWN",
  clickTabBulkUpdates = "CLICK_TAB_BULK_UPDATES",
  // Menu Items
  clickCreateItems = "CLICK_CREATE_ITEMS",
  clickEditItems = "CLICK_EDIT_ITEMS",
  // Feedback
  clickFeedback = "CLICK_FEEDBACK",
  clickSubmit = "CLICK_SUBMIT",
  errorSubmit = "ERROR_SUBMIT",
  uploadPhoto = "UPLOAD_PHOTO",
  reportStatus = "REPORT_STATUS",
  clickReply = "CLICK_REPLY",
  replySuccessful = "REPLY_SUCCESSFUL",
  replyUnsuccessful = "REPLY_UNSUCCESSFUL",
  editReply = "EDIT_REPLY",
  editSuccessful = "EDIT_SUCCESSFUL",
  editUnsuccessful = "EDIT_UNSUCCESSFUL",
  clickReport = "CLICK_REPORT",
  reportSuccessful = "REPORT_SUCCESSFUL",
  reportUnsuccessful = "REPORT_UNSUCCESSFUL",
  expandHighest = "EXPAND_HIGHEST_STORELIST",
  expandLowest = "EXPAND_LOWEST_STORELIST",
  closeList = "CLOSE_LIST",
  multipleTab = "MULTIPLE_TAB",
  // Grabx
  initialize = "INITIALIZE",
  getFeature = "GET_FEATURE",
  // Store Status
  submitChangeStoreStatus = "SUBMIT_CHANGE_STORE_STATUS",
  showChangeStoreStatusButton = "SHOW_CHANGE_STORE_STATUS_BUTTON",
  clickButtonThenModalOpened = "CLICK_BUTTON_THEN_MODAL_OPENED",
  BusyOptionShown = "BUSY_OPTION_SHOWN",
  // Incidents
  showAffectedItems = "SHOW_AFFECTED_ITEMS",
  appealIncident = "APPEAL_INCIDENT",
}

export enum EventCategoryPrefix {
  menu = "MENU_",
  menuGroup = "MENU_GROUP_",
  menuGroupCreation = "MENU_GROUP_CREATION_",
  inventory = "INVENTORY_",
}

export enum EventCategory {
  storeTab = "STORE_TAB",
  ordersTab = "ORDERS_TAB",
  transactionTab = "TRANSACTION_TAB",
  instoreOVOTransactionTab = "INSTORE_OVO_TRANSACTION_TAB",
  sidebarNavigation = "SIDE_BAR_NAVIGATION",
  grabx = "GRABX",
  pageOpen = "PAGE_OPEN",
  notFoundPage = "NOT_FOUND_PAGE",
  endpoint = "ENDPOINT",
  // Menu
  menuHomePage = "MENU_HOMEPAGE",
  // Menu Editor - used by menu group and inventory
  menuOverviewTab = "MENU_OVERVIEW_TAB",
  menuItemsTab = "MENU_ITEMS_TAB",
  menuModifierGroupsTab = "MENU_MODIFIERGROUPS_TAB",
  menuBulkUploadTab = "MENU_BULK_UPLOAD_TAB", // TODO update when receiving instrumentation requirement
  menuOverviewRearrangeCategory = "MENU_OVERVIEW_REARRANGECATEGORY",
  menuOverviewRearrangeDepartment = "MENU_OVERVIEW_REARRANGECATEGORY",
  menuOverviewRearrangeSubDepartment = "MENU_OVERVIEW_REARRANGESUBCATEGORY",
  menuOverviewRearrangeItem = "MENU_OVERVIEW_REARRANGEITEM",
  menuOverviewModifyItem = "MENU_OVERVIEW_MODIFYITEM",
  menuOverviewModifyCategory = "MENU_OVERVIEW_MODIFYCATEGORY",
  menuOverviewModifySection = "MENU_OVERVIEW_MODIFYSECTION",
  menuOverviewModifySellingTime = "MENU_OVERVIEW_MODIFYSELLINGTIME",
  menuItemsModifyitem = "MENU_ITEMS_MODIFYITEM",
  menuItemsModifySellingTime = "MENU_ITEMS_MODIFYSELLINGTIME",
  menuModifiergroupsModifymodifiergroup = "MENU_MODIFIERGROUPS_MODIFYMODIFIERGROUP",
  menuModifiergroupsRearrangeModifier = "MENU_MODIFIERGROUPS_REARRANGEMODIFIER",
  // Menu Group
  menuGroupHomePage = "MENU_GROUP_HOMEPAGE",
  menuGroupCreationSelectStores = "MENU_GROUP_CREATION_SELECT_STORES",
  menuGroupCreationSelectMenu = "MENU_GROUP_CREATION_SELECT_MENU",
  menuGroupCreationExistingMenu = "MENU_GROUP_CREATION_EXISTING_MENU",
  menuGroupCreationMenuOverview = "MENU_GROUP_CREATION_MENU_OVERVIEW",
  menuGroupCreationReview = "MENU_GROUP_CREATION_REVIEW",
  menuGroupDetail = "MENU_GROUP_DETAIL",
  menuGroupEdit = "MENU_GROUP_EDIT",
  menuGroupDelete = "MENU_GROUP_DELETE",
  menuGroupEditStores = "MENU_GROUP_EDIT_STORES",
  menuGroupAddStores = "MENU_GROUP_ADD_STORES",
  menuGroupItemsTab = "MENU_GROUP_ITEMS_TAB",
  // Inventory
  inventoryHomePage = "INVENTORY_HOMEPAGE",
  inventoryBulkupdatesTab = "INVENTORY_BULKUPDATES_TAB",
  bulkEditinventoryTab = "BULK_EDITINVENTORY_TAB",
  bulkEditDownloadcatalogueTab = "BULK_EDIT_DOWNLOADCATALOGUE_TAB",
  inventoryEditCompleted = "INVENTORY_EDIT_COMPLETED",
  inventoryEditErrorfound = "INVENTORY_EDIT_ERRORFOUND",

  // Menu Items
  menuBulkupdatesTab = "MENU_BULKUPDATES_TAB",
  bulkEditmenuTab = "BULK_EDITMENU_TAB",
  bulkEditMenuDownloadcatalogue = "BULK_EDITMENU_DOWNLOAD_CATALOGUE",
  menuEditCompleted = "MENU_EDIT_COMPLETED",
  menuEditErrorfound = "MENU_EDIT_ERRORFOUND",

  // Feedback
  feedbackReply = "FEEDBACK_REPLY",
  feedbackReplyEdit = "FEEDBACK_REPLY_EDIT",
  feedbackReport = "FEEDBACK_REPORT",
  feedbackReportDetails = "REPORT_DETAILS",
  feedbackHomePage = "FEEDBACK_HOMEPAGE",

  // Incidents
  incidentsList = "INCIDENTS_LIST",
  incidentListFromQuery = "INCIDENTS_LIST_FROM_QUERY",
  incidentListFromDefault = "INCIDENTS_LIST_FROM_DEFAULT",
  incidentDetail = "INCIDENT_DETAIL",
  incidentFilterByDate = "INCIDENT_FILTER_BY_DATE",
  incidentFilterByIncidentType = "INCIDENT_FILTER_BY_INCIDENT_TYPE",
  incidentFilterByResolutionType = "INCIDENT_FILTER_BY_RESOLUTION_TYPE",
  incidentFilterBySelectedMerchantID = "INCIDENT_FILTER_BY_SELECTED_MERCHANT_ID",

  // Store Status
  changeStoreStatus = "CHANGE_STORE_STATUS",
}

// Event Tracker for Engineering Team Purpose
export enum EventActionEng {
  showStoreList = "SHOW_STORE_LIST",
  errorFetchMerchant = "ERROR_FETCH_NEW_MERCHANT",
  errorFetchMerchantV2 = "ERROR_FETCH_MERCHANTV2",
  stopIntersectionObserver = "STOP_INTERSECTION_OBSERVER",
  submitMemoryMetrics = "SUBMIT_MEMORY_METRICS",
  submitMemoryMetricsFail = "SUBMIT_MEMORY_METRICS_FAIL",

  // Menu Translation
  categoryAutoTranslationFetch = "CATEGORY_AUTO_TRANSLATION_FETCH",
  itemAutoTranslationFetch = "ITEM_AUTO_TRANSLATION_FETCH",
  modifierAutoTranslationFetch = "MODIFIER_TRANSLATION_FETCH",
  resetTranslationFetch = "RESET_TRANSLATION_FETCH",
  showCategoryTranslation = "SHOW_CATEGORY_TRANSLATION_DRAWER",
  showItemTranslation = "SHOW_ITEM_TRANSLATION_DRAWER",
  showModifierTranslation = "SHOW_MODIFIER_TRANSLATION_DRAWER",
  verifyTranslationFail = "VERIFY_TRANSLATION_FAIL",
  verifyTranslationSuccess = "VERIFY_TRANSLATION_SUCCESS",

  // Feedback
  showBulkDownloadModal = "SHOW_BULK_DOWNLOAD_MODAL",

  // Feedback Bulk Download
  startBulkDownload = "START_BULK_DOWNLOAD",
  interruptBulkDownload = "INTERRUPT_BULK_DOWNLOAD",
  doneBulkDownload = "DONE_BULK_DOWNLOAD",

  // RTK Query Migration
  fetchIncidentStat = "FETCH_INCIDENT_STAT",
  fetchIncidentList = "FETCH_INCIDENT_LIST",
  searchOutletsPaginatedInfinite = "SEARCH_OUTLETS_PAGINATED_INFINITE",
}

// Event Category for Engineering Team Purpose
export enum EventCategoryEng {
  storeList = "STORE_LIST",
  newMerchantEndpoint = "NEW_MERCHANT_ENDPOINT",
  errorMerchantV2 = "ERROR_MERCHANTV2",
  intersectionObserver = "INTERSECTION_OBSERVER",
  performance = "PERFORMANCE",

  // Menu Translation
  translationValueFetch = "GET_TRANSLATION_VALUE",
  verifyTranslation = "VERIFY_TRANSLATION",
  showTranslationDrawer = "SHOW_TRANSLATION_DRAWER",

  // Feedback Bulk Download
  feedbackBulkDownload = "FEEDBACK_BULK_DOWNLOAD",

  // RTK Query Migration
  rtkMigration = "RTK_MIGRATION",
}

export enum EventEntryPoint {
  menuItemsModifyItem = "MENU_ITEMS_MODIFYITEM",
  menuOverviewModifyCategory = "MENU_OVERVIEW_MODIFYCATEGORY",
  menuOverviewBottomNav = "MENU_OVERVIEW_BOTTOMNAV",
  addNewDropdown = "ADD_NEW_DROPDOWN",
  availabilityDropdown = "AVAILABILITY_DROPDOWN",
  itemListingPage = "ITEM_LISTING_PAGE",
  createItemButton = "CREATE_ITEM_BUTTON",
  categoryMoreButton = "CATEGORY_MORE_BUTTON",
}

export enum Language {
  en = "English",
  id = "Bahasa",
}

export enum EventLabelKeys {
  defaultLanguageShowed = "DEFAULT_LANGUAGE_SHOWED",
  selectedLanguage = "SELECTED_LANGUAGE",
  clickText = "CLICK_TEXT",
  filterText = "FILTER_TEXT",
}

export enum UserTypes {
  merchant = "MERCHANT",
  consumer = "CONSUMER",
  store = "STORE",
  individualMerchant = "INDIVIDUAL_MERCHANT",
  individualStore = "INDIVIDUAL_STORE",
  mlmMerchant = "MLM_MERCHANT",
  mlmStore = "MLM_STORE",
  mlmTerminal = "MLM_TERMINAL",
  gtwyMerchant = "GTWY_MERCHANT",
  gtwyStore = "GTWY_STORE",
  ptnrMerchant = "PTNR_MERCHANT",
  ptnrStore = "PTNR_STORE",
  offlineAcquirer = "OFFLINE_ACQUIRER",
}

export enum SellingTimeEditType {
  addSellingTime = "Add Selling Time",
  editSellingTime = "Edit Selling Time",
}

export enum SellingTimeSource {
  sellingTimeFilter = "Selling Time Filter",
  categoryDetailEdit = "Category Detail Edit",
  itemDetailEdit = "Item Detail Edit",
  selectMultipleItem = "Select Multiple Item",
}

export enum editType {
  create = "CREATE",
  edit = "EDIT",
}

export enum merchantType {
  single = "SINGLE",
  multi = "MULTI",
}

export enum itemsEdited {
  allItems = "ALL_ITEMS",
  partialItems = "PARTIAL_ITEMS",
}

export enum StoreStatus {
  normal = "Normal",
  busy = "Busy",
  paused = "Paused",
  closed = "Closed",
}

export const UnknownStoreStatus = "Unknown"

export enum StoreStatusForEndpointParam {
  normal = "NORMAL",
  paused = "TEMPPAUSED",
  busy = "BUSY",
  opsPaused = "OPSPAUSED",
}

export const durationAdjustment = 5

export enum storeCloseReasons { // Defined in file path ‘food/common/maxstate/status.go’
  MexPaused = 1,
  OpsPaused = 2,
  OutOfSpecialOpeningHours = 3,
  OutOfOpeningHours = 4,
  InActive = 5,
  OpsPausedWithoutComm = 6, // OpsPausedWithoutComm ... Ops paused but no need to communicate with merchant
  Restricted = 7, // Restricted means merchant is suspect as fraud, store is closed
  Suspended = 8, // Suspended means merchant is fraud, store is closed
}

export enum busyModeApproach { // defined in file path 'food/common/types/mexbusymode/strategy.go'
  StartPrepareBeforeFindDriver = 1,
  StartPrepareAfterFindDriver = 2,
  SmartBusyMode = 3,
}

export enum FilterTrigger {
  searchInput = "SEARCH_INPUT",
  sort = "SORT",
  cityFilter = "CITY_FILTER",
  autoCompleteSelect = "AUTO_COMPLETE_SELECT",
  menuList = "MENU_LIST",
  orderList = "ORDER_LIST",
}

export enum SearchItemTrigger {
  searchInput = "SEARCH_INPUT",
  refetch = "REFETCH",
}
